<template>
    <div style="height: 100%">
        <!-- 面包屑导航 -->
        <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
        <!-- 面包屑导航 -->
        <div class="content c-top">
            <div class="title">
                <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
                <!-- <h3>角色设置</h3> -->
                <div style="display:flex">
                    <div class="u-btn" @click="deleteF('lot', [])">批量删除</div>
                    <el-button type="primary" icon="el-icon-plus" @click="add" size="small">添加</el-button>
                </div>
            </div>
            <div id="base-list">
                <lb-table style="padding-bottom: 40px" v-loading="loading" v-horizontal-scroll="'always'" :column="columns"
                    pagination :data="list" :total="totalNum" layout="total, sizes, prev, pager, next, jumper"
                    :page-sizes="[5, 10, 20, 30, 50]" :current-page.sync="pageNo" :page-size="pageSize"
                    @selection-change="onMultipleSelection" @size-change="handleSizeChange"
                    @p-current-change="handleCurrentChange">
                </lb-table>
            </div>
        </div>
        <el-dialog :title="title" :visible.sync="isEdit" width="50%" :append-to-body="true">
            <template>
                <el-form label-width="100px" size="small" :model="form" :rules="rules" ref="refForm">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="form.name" placeholder="请输入名称" style="width: 100%">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="值" prop="value">
                        <el-input v-model="form.value" placeholder="请输入值" style="width: 100%">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="唯一标识符" prop="code">
                        <el-input v-model="form.code" placeholder="请输入唯一标识符" style="width: 100%">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注" prop="remark">
                        <quill-editor v-model="form.remark" ref="myQuillEditor" :options="editorOption"
                            class="editor"></quill-editor>
                        <div class="bottom" style="display: none">
                            <el-upload class="centerImg" :action="' '" list-type="picture-card" :auto-upload="false"
                                :on-change="handleAvatarChangeIcon" ref="uploadicon">
                            </el-upload>
                        </div>
                    </el-form-item>
                </el-form>

                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isEdit = false">取消</div>
                    <div class="info-s" @click="addSubmit">确定</div>
                    <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
            <el-button type="primary" @click="isUp = false">确定</el-button> -->
                </div>
            </template>
        </el-dialog>
        <el-dialog title="温馨提示" :visible.sync="isD" width="518px" :append-to-body="true" top="calc(50vh - 100px)">
            <template>
                <div class="info" style="text-align: left">
                    <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>
                    是否确认删除，删除后数据不可恢复！
                </div>
                <div style="display: flex; justify-content: end; margin-top: 24px">
                    <div class="info-q" @click="isD = false">取消</div>
                    <div class="info-s" @click="submitD()">确定</div>
                </div>
            </template>
        </el-dialog>

    </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import LbTable from '../../../components/lb-table/lb-table'
import { quillEditor } from 'vue-quill-editor'
export default {
    components: {
        breadcrumbTop,
        breadcrumbSearch,
        LbTable,
        quillEditor
    },
    data() {
        return {
            dId: [],
            isD: false,
            editorOption: {},
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            title: '添加',
            isEdit: false,
            isRole: false,
            name: '',
            dataList: {
                list: [
                    { title: '系统管理', path: '', type: '0' },
                    { title: '功能设置', path: '', type: '1' }
                ]
            },
            searchList: {
                list: [
                    { title: '功能设置', path: '', type: '0' },
                    { title: '首页弹框设置', path: '', type: '1' },
                ]
            },

            form: {
                name: '',
                value: '',
                code: '',
                remark: '',
                id: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' },
                ],
                value: [
                    { required: true, message: '请输入值', trigger: 'blur' },
                ],
                code: [
                    { required: true, message: '请输入唯一标识符', trigger: 'blur' },
                ],

                remark: [
                    { required: false, message: '请输入备注', trigger: 'blur' },
                ],

            },
            value1: [],
            brandList: [],
            columns: [
                { type: 'selection', minWidth: '80', fixed: 'left' },
                { label: 'ID', prop: 'id', minWidth: '80' },
                { label: '名称', prop: 'name', minWidth: '120' },
                {
                    label: '值', prop: 'value', minWidth: '120',
                    render: (h, scope) => {
                        return (
                            <div>
                                <p style="max-height: 60px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{scope.row.value ? scope.row.value : '--'}</p>
                            </div>

                        )
                    }
                },
                {
                    label: '唯一标识', minWidth: '220',
                    render: (h, scope) => {
                        return (
                            <div style="display:flex;flex-wrap:wrap;justify-content:center">
                                {scope.row.code}
                            </div>

                        )
                    }
                },
                {
                    label: '描述', prop: 'remark', minWidth: '100',
                    render: (h, scope) => {
                        // let v = <div>
                        //     <p>{scope.row.remark}</p>
                        // </div >
                        return (
                            <div>
                                <p style="max-height: 60px;line-height:30px; overflow: hidden;text-overflow: ellipsis;word-break: break-all;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;">{scope.row.remark ? scope.row.remark : '--'}</p>
                            </div>

                        )
                    }
                },
                {
                    label: '操作',
                    width: '180',
                    fixed: 'right',
                    render: (h, scope) => {
                        return (
                            <div>
                                <span style='color:#2D46EE;cursor:pointer' onClick={() => { this.edit(scope.row) }}>编辑</span>
                                <span style='color:#2D46EE;cursor:pointer;margin-left:12px' onClick={() => { this.deleteF('single', scope.row.id) }}>删除</span>
                            </div >
                        )
                    }
                }],
            page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
            list: [],
            loading: true,
            roleLimits: JSON.parse(sessionStorage.getItem('limit')).menuTreeList,
            roleId: null,
            selectedLimits: [],
            pageNo: 1,
            pageSize: 10,
            totalNum: 0
        }
    },
    created() {
        this.getList()
        console.log(this.roleLimits)
    },
    methods: {
        onMultipleSelection(e) {
            console.log(e)
            e.forEach(item => {
                this.dId.push(item.id)
            })
        },
        deleteF(type, id) {

            if (type == 'single') {
                this.dId = []
                this.dId.push(id)
                this.isD = true
            } else {
                if (this.dId.length == 0) {
                    this.$message.warning('请选择')
                } else {
                    this.isD = true
                }
            }

        },
        submitD() {
            let data = {
                ids: this.dId
            }
            this.axios.post('/sysInfo/delete', data)
                .then(res => {
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.isD = false
                        this.getList()

                    }

                })
        },
        handleAvatarChangeIcon() {

        },
        getSelected() {
            let menuIds = this.$refs.tree.getCheckedKeys(false, true)
            let dd = this.$refs.tree.getHalfCheckedKeys()
            menuIds = menuIds.concat(dd)
            menuIds = [...new Set(menuIds)]
            console.log('dd==', dd)
            console.log('menuIds=', menuIds)
            // return
            if (menuIds.length == 0) {
                return this.$message.warning('请选择角色权限')
            }
            let data = {
                roleId: this.roleId,
                menuIds: menuIds
            }
            this.axios.post('/role/updatePermission/', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.isRole = false;
                        this.getRoleList()
                    }
                })

        },
        getRoleLimits(row) {
            this.selectedLimits = []
            this.roleId = row.id;
            this.axios.get('/role/menuList/' + row.id)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.isRole = true;
                        // this.roleLimits = res.data;
                        if (row.menuList.length > 0) {
                            console.log(row.menuList)

                            for (let i = row.menuList.length - 1; i >= 0; i--) {
                                if (row.menuList[i].menuName == '用户管理' || row.menuList[i].menuName == '商品管理' || row.menuList[i].menuName == '订单管理' || row.menuList[i].menuName == '财务管理' || row.menuList[i].menuName == '商城管理' || row.menuList[i].menuName == '系统管理') {
                                    row.menuList.splice(i, 1)
                                    // console.log(row.menuList[i].name)
                                }
                            }
                            this.selectedLimits = row.menuList.map(item => {
                                return item.menuId
                            })
                            // this.selectedLimits.splice(1,1)
                            console.log(this.selectedLimits)
                        } else {
                            console.log(5555555)
                            this.selectedLimits = []
                        }
                        this.$forceUpdate()
                    }
                })
        },
        handleCurrentChange(e) {
            this.pageNo = e;
            this.getList()
        },
        handleSizeChange(e) {
            this.pageSize = e;
            this.pageNo = 1;
            this.getList()
        },
        addSubmit() {
            this.$refs['refForm'].validate((valid) => {
                if (valid) {
                    this.axios.post('/sysInfo/save', this.form)
                        .then(res => {
                            if (res.code == 0) {
                                if (this.title == '添加') {
                                    this.$message.success('添加成功')
                                } else {
                                    this.$message.success('编辑成功')
                                }
                                this.isEdit = false
                                this.getList()
                            }

                        })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        },
        getList() {
            let data = {
                pageNo: this.pageNo,
                pageSize: this.pageSize
            }
            this.axios.post('/sysInfo/getInfoPageList', data)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.loading = false;
                        this.list = res.data.list;
                        this.totalNum = res.data.totalNum
                        res.data.list.forEach(item => {
                            item.remark = this.html2text(item.remark)

                        })
                    }

                })
        },
        //将富文本连同input框转换为文本
        html2text(html) {
            const el = document.createElement('div');
            el.id = 'panel';
            el.innerHTML = html
            var inputs = el.getElementsByTagName("input");
            for (var i = 0; i < inputs.length; i++) {
                inputs[i].parentNode.innerHTML = inputs[i].value;
            }
            return el.innerText
        },

        add() {
            this.isEdit = true
            this.title = '添加'
            if (this.$refs.refForm) {
                this.$refs.refForm.resetFields()
            }
        },
        edit(row) {
            this.isEdit = true
            this.title = '编辑'
            this.axios.get('/sysInfo/get?id=' + row.id)
                .then(res => {
                    console.log(res)
                    if (res.code == 0) {
                        this.form = res.data
                    }

                })
        },
    }
}
</script>
  
<style scoped lang="scss">
.u-btn {
    width: 92px;
    height: 34px;
    background: #FFFFFF;
    border: 1px solid #2D46EE;
    opacity: 1;
    border-radius: 3px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 36px;
    color: #2D46EE;
    text-align: center;
    cursor: pointer;
    margin-right: 18px;
}

::v-deep .el-tree-node__content {
    display: flex;
    align-items: center;
    height: 55px;
    cursor: pointer;
}

// 自定义图标中隐藏自带箭头
::v-deep .el-tree-node__content>.el-tree-node__expand-icon {
    position: absolute;
    opacity: 0;
}

::v-deep .el-tree-node__content {
    position: relative;
}

::v-deep .el-input--prefix .el-input__inner {
    padding-left: 80px;
}

::v-deep .el-dialog__wrapper {
    text-align: center;
    white-space: nowrap;
    overflow: auto;

    &:after {
        content: "";
        display: inline-block;
        vertical-align: middle;
        height: 100%;
    }

    .el-dialog {
        margin: 30px auto !important;
        display: inline-block;
        vertical-align: middle;
        text-align: center;
        white-space: normal;
    }
}

::v-deep .el-dialog__header {
    text-align: left;
    border-bottom: none;
}

.info {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 0px;
    color: #303033;
    opacity: 1;
    text-align: left;
}

.info-b {
    margin-left: 20px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    line-height: 40px;
    color: #303033;
    text-align: left;
}

.info-q {
    width: 124px;
    height: 40px;
    line-height: 40px;
    background: #ffffff;
    border: 1px solid #909099;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #909099;
    margin-right: 18px;
    cursor: pointer;
}

.info-s {
    width: 126px;
    height: 40px;
    line-height: 40px;
    background: #2d46ee;
    opacity: 1;
    border-radius: 3px;
    text-align: center;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    cursor: pointer;
}

.title {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

#base-list {
    margin-top: 20px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
    display: inline-block;

    a {
        margin: 0 5px;
    }
}

.search-form {
    // margin-top: 20px;
    display: flex;
    flex-wrap: wrap;

    .el-form-item {
        /deep/ .el-form-item__label {
            width: 100px;
            text-align: right;
            vertical-align: middle;
            float: left;
            box-sizing: border-box;
        }

        /deep/ .el-form-item__content {
            display: block;
            margin-left: 100px;

            .el-cascader,
            .el-select {
                width: 100%;
            }
        }
    }
}

.limits-item {}
</style>
  
  